import useComponentExcludeNull from '@kanrisha/composables/useComponentExcludeNull';
import useComponentFilters from '@kanrisha/composables/useComponentFilters';
import { ref } from 'vue';

export default function useResourceParams(props) {
  const { localExcludeNull } = useComponentExcludeNull(props);
  const { localFilter, getActiveFilters, paramsWithoutFilter } = useComponentFilters(props);
  let resource = props.resource ?? props.models ?? props.model;
  const localSort = ref(props.sort ?? props.adjustments?.sort ?? resource.meta.adjustments?.sort);

  const getIndexParams = (column = null, pickedModel = null) => {
    return {
      sort: column == localSort.value ? '-' + column : column,
      filter: localFilter.value,
      picked: pickedModel,
      page: resource.page?.current_page ?? 1,
      parent: props.parentResource ?? null,
      relation: props.options?.relation?.name ?? null,
    };
  };

  const getModelParams = (model) => {
    let params = {};
    params[resource.meta.modelType.replace('-', '_')] = model.data;

    return params;
  };

  const getPickedParams = (model, pickedModel) => {
    return {
      id: model.data.id,
      picked: pickedModel.data.id,
      relation: pickedModel.meta.relationInfo?.name,
    };
  };

  return {
    getActiveFilters,
    getIndexParams,
    getModelParams,
    getPickedParams,
    localExcludeNull,
    localFilter,
    localSort,
    paramsWithoutFilter,
  };
}
